module.exports = __webpack_public_path__ + "static/img/LxxljkscV3.c99c70f2.png";